/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Announcement_HistoryInputs */



/**
* | output |
* | --- |
* | "Earlier announcements ({count})" |
*
* @param {Announcement_HistoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const announcement_history = /** @type {((inputs: Announcement_HistoryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcement_HistoryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Annonces précédentes (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Anuncios anteriores (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Anúncios anteriores (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Annunci precedenti (${i?.count})`)
	return /** @type {LocalizedString} */ (`Earlier announcements (${i?.count})`)
});